export const DEFAULT_PROTOCOL_ID = 'default';